(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball-row/assets/javascripts/ball-row-lotto.js') >= 0) return;  svs.modules.push('/components/tur/ball-row/assets/javascripts/ball-row-lotto.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.row = svs.tur.ball.row || {};
class RowLotto extends svs.tur.ball.row.Default {
  constructor(_ref) {
    let {
      balls = [],
      numbers = [],
      extraNumbers = [],
      description,
      showWinInfo = false,
      order,
      index,
      size,
      questionMarkWinInfo
    } = _ref;
    super({
      balls,
      numbers,
      extraNumbers,
      description,
      index,
      order,
      size,
      showWinInfo,
      questionMarkWinInfo,
      BallClass: svs.tur.ball.Lotto
    });
    this._numbers = numbers;
    this._balls = balls;
  }
  classNames() {
    return ['ball-row-lotto'];
  }
}
svs.tur.ball.row.Lotto = RowLotto;

 })(window);